<template>
  <b-modal
    ref="modal"
    title="Pesquisar turnos anteriores"
    header-class="border-bottom-0"
    hide-footer
    size="xl"
  >
    <div class="container-fluid">
      <table-paginator :data="shifts" @pagechange="handlePageChange($event)">
        
        <div class="row pt-4 pb-2">
          <div class="col-md-6">Aberto em:</div>
          <div class="col-md-6">Fechado em:</div>
        </div>
        <hr class="my-0" />
        <template v-for="shift in shifts.data">
          <div class="row py-3" @click="handleSelectShift(shift)" style="cursor:pointer">
            <div class="col-md-6">
              {{ shift.started_at | dateTimeBr }}
              <br />
              {{ shift.started_by_user.name }}
            </div>
            <div class="col-md-6">
              <template v-if="shift.status == 'c'">
                {{ shift.ended_at | dateTimeBr }}
                <br />
                {{ shift.ended_by_user.name }}
              </template>
            </div>
          </div>
          <hr class="my-0" />
        </template>
        <br>
      </table-paginator>
    </div>
  </b-modal>
</template>

<script>

import TablePaginator from "@/components/sections/TablePaginator";

export default {
  components : { TablePaginator },

  data: () => ({
    shifts: {
      data: [],
    },

    form: {
      account_id: null,
      page : 1
    },
  }),

  methods: {
    async open(accountId) {
      this.form.account_id = accountId;
      this.form.page = 1

      this.$store.commit("showLoading");
      
      await this.select()

      this.$refs.modal.show();
      
      this.$store.commit("hide");
    },

    async select() {
      this.$store.commit("showLoading");

      let response = await this.$store.dispatch("drawer/getShifts", this.form);
      
      this.shifts = response.shifts;

      this.$store.commit("hideLoading");
    },

    handlePageChange(page) {
      this.form.page = page

      this.select()
    },

    handleSelectShift(shiftId) {
      this.$emit("input", shiftId);
      this.$refs.modal.hide();
    },
  },
};
</script>

<style>
</style>